import React from "react";
import {ethers,utils} from "ethers";
import {getProvider} from "./Provider";
import { useState } from "react";

// components

import CardStats from "components/Cards/CardStats.js";
export default function Settings() {

  
//console.log( mywallet); 

  const [myearnings,setmyearnings]=useState();
  const [mybalance,setmybalance]=useState();
  const [mybalanceX,setmybalanceX]=useState();
  const [myTotalEarning,setmyTotalEarning]=useState();
  const address = "0x8B6D8e0a3d407007a84644968bF18763e11B3458";
const abi = [
  "function earned(address account) view returns (uint256)",
  "function _balances(address) view returns (uint256)"
];
//await earned().then().catch()
 
  function convert(bigNumber, unit="ether"){
    if(typeof bigNumber !== "object") return bigNumber;
    return utils.formatUnits(bigNumber.toString(),unit);

  }
  async function _balances() {
    const provider = await getProvider()
  const signer = provider.getSigner()
    const contract = new ethers.Contract(address, abi, signer);   
    const account = await provider.listAccounts();
    const result = await contract.functions._balances(account[0]);
  

    setmyTotalEarning(convert(result[0]))
  }
  _balances();

 

  // if(window.ethereum){
  //   const provider = new ethers.providers.Web3Provider(window.ethereum)
  // const signer = provider.getSigner()
  balanceOf()
  balanceOfX()
   earned();
   async function earned() {
    const provider = await getProvider()
    const signer = provider.getSigner()
    const contract = new ethers.Contract(address, abi, signer);   
    const account = await provider.listAccounts();
    const result = await contract.functions.earned(account[0]);
  
   // console.log("result", result[0]);
    setmyearnings(convert(result[0]))
  }


   async function balanceOf() {
    const provider = await getProvider()
    const signer = provider.getSigner()
    const MTaddress = "0x6364c250a26f171e05b9D26b66baB17921eC72b9";
const MTabi = [
  "function balanceOf(address account) view returns (uint256)"
];
const account = await provider.listAccounts();
    const contract = new ethers.Contract(MTaddress, MTabi, signer);   
    const result = await contract.functions.balanceOf(account[0]);
  
   // console.log("result", result);
    setmybalance(convert(result[0]))
  } 
  async function balanceOfX() {
    const provider = await getProvider()
    const signer = provider.getSigner()
    const XMTaddress = "0xE99c1deB0234CE433DA7233D0a8934Fb379e600b";
const XMTabi = [
  "function balanceOf(address account) view returns (uint256)"
];
const account = await provider.listAccounts();
    const contract = new ethers.Contract(XMTaddress, XMTabi, signer);   
    const result = await contract.functions.balanceOf(account[0]);
  
   // console.log("result", result);
    setmybalanceX(convert(parseInt(result[0])))
  } 


// }else{
//   alert("Use A Dapp Browser")
// }
// if(!window.ethereum){
//   alert("Use a DAPP Browser")
// }
   
  
 
 ;
  return (
    <>
      <div style={{
        marginTop:"100px"
      }} className="relative my-Font bg-lightBlue-white md:pt-32 pb-32 pt-12">
        <div className="px-4 md:px-10 mx-auto w-full">
          <div className="flex flex-col">
            {/* Card stats */}
            <div className="flex flex-row">
              <div className="w-full lg:w-full py-6 xl:full px-4">
                <CardStats
                  statSubtitle="Your MFA  Balance"
                  statTitle={mybalance}
                  statArrow=""
                  statPercent=''
                  statPercentColor=""
                  statDescripiron=""
                  statIconName="far fa-chart-bar"
                  statIconColor="bg-red-500"
                />
              </div>
             
            </div>
            <div className="flex flex-row">
              <div className="w-full lg:w-full py-6 xl:full px-4">
                <CardStats
                  statSubtitle="You have Earned"
                  statTitle={myearnings}
                  statArrow=""
                  statPercent=""
                  statPercentColor=""
                  statDescripiron=""
                  statIconName="far fa-chart-bar"
                  statIconColor="bg-red-500"
                />
              </div>
             
            </div>
            <div className="flex flex-row">
              <div className="w-full lg:w-full py-6 xl:full px-4">
                <CardStats
                  statSubtitle="Your Initial Investment"
                  statTitle={myTotalEarning}
                  statArrow=""
                  statPercent=''
                  statPercentColor=""
                  statDescripiron=""
                  statIconName="far fa-chart-bar"
                  statIconColor="bg-red-500"
                />
              </div>
             
            </div>
{/* <div className="flex flex-row">
             
              <div className="w-full lg:w-1/3 xl:w-1/3 py-6 px-4">
                <CardStats
                  statSubtitle="Your XMFA Balance"
                  statTitle={mybalanceX}
                  statArrow=""
                  statPercent=""
                  statPercentColor=""
                  statDescripiron=""
                  statIconName="fas fa-percent"
                  statIconColor="bg-lightBlue-500"
                />
              </div>
              
            </div>
            */}
          
          </div>
        </div>
      </div>
    </>
  );
}
